let info = {
  name: "장진서",
  logo_name: "Jang",
  flat_picture: require("./src/assets/me.png"),
  config: {
    use_cookies: true,
    navbar: {
      blur: false
    }
  },
  description:
    "건국대학교 컴퓨터공학과를 졸업하여 카카오게임즈 2020공채 신입으로 입사했습니다. 웹/앱 서비스에 대한 프론트, 백앤드 개발을 했으며 프론트는 Flutter, 백엔드는 JAVA Spring 프레임워크를 주로 사용했습니다. 2021년부터 멘사 회원으로도 활동하고 있습니다.",
  links: {
    // linkedin: "https://www.linkedin.com/in/mahy-mohab-209/",
    github: "https://github.com/jamesdev297",
    // behance: "https://www.behance.net/mahymohab",
    // resume: "https://drive.google.com/file/d/1W0pzOo1Gb-W70BYKehOfZ4qaJt7m1_7O/view?usp=sharing",
  },
  education: [
    {
      name: "건국대학교",
      place: "서울캠퍼스",
      date: "2014 - 2020",
      degree: "컴퓨터공학과",
      description:
        "",
      skills: [
        // "Software Engineering",
        // "web programming",
        // "UI/UX design",
        // "Front-end developing",
      ]
    },
  ],
  experience: [
    {
      name: "엔씨소프트",
      place: "인턴",
      date: "2020.7 - 2020.9",
      position: "서버 개발",
      description: "",
      skills: ["C++", "IOCP"]
    },
    {
      name: "카카오게임즈",
      place: "신입 공채",
      date: "2020.11 - 2021.5",
      position: "웹 프론트엔드, 백엔드 개발",
      description: "",
      skills: ["Vue.js", "JAVA", "Spring"]
    },
    {
      name: "라이프엠엠오",
      place: "사원",
      date: "2021.5 - 2023.3",
      position: "웹/앱 프론트엔드, 백엔드 개발",
      description: "서비스 웹/앱 프론트엔드, 백엔드 개발",
      skills: ["Flutter", "JAVA", "Spring", "Node.js", "Python"]
    },
    {
      name: "카카오게임즈",
      place: "사원",
      date: "2023.3 - 현재",
      position: "웹/앱 프론트엔드, 백엔드 개발",
      description: "서비스 웹/앱 프론트엔드, 백엔드 개발",
      skills: ["Flutter", "JAVA", "Spring", "Node.js", "Python"]
    },
  ],
  skills: [
    {
      title: "언어",
      info: ["Dart","JAVA","C#","C++","Node.js","Python","Javascript"],
      icon: "fa fa-code"
    },
    {
      title: "프론트엔드",
      info: ["Flutter","HTML","CSS"],
      icon: "fa fa-cubes"
    },
    {
      title: "백엔드",
      info: ["Spring", "Node", "AWS Lambda", "MySQL"],
      icon: "fa fa-server"
    },
    {
      title: "게임",
      info: ["Unity"],
      icon: "fa fa-gamepad"
    }
  ],
  portfolio_design: [
    {
      name: "Keep it Green",
      title: "UI/UX Design",
      pictures: [
        {
          img: require("./src/assets/designs/Keep it green/cover.png"),
          title: "MoodBoard"
        },
        {
          img: require("./src/assets/designs/Keep it green/show.png"),
          title: "show"
        },
      ],
      technologies: ["Figma", "Photoshop"],
      category: "Visual Design",
      github: "",
      date: "Jan, 2022",
      visit: "",
      description: ""
    },
    {
      name: "Digital agency website",
      title: "UI/UX Design",
      pictures: [
        {
          img: require("./src/assets/designs/digital agency/behance cover.png"),
          title: "MoodBoard"
        },
        {
          img: require("./src/assets/designs/digital agency/1. start.png"),
          title: "App Elements"
        },
        {
          img: require("./src/assets/designs/digital agency/2. about.png"),
          title: "App Elements"
        },
        {
          img: require("./src/assets/designs/digital agency/3. Our services.png"),
          title: "App Elements"
        },
        {
          img: require("./src/assets/designs/digital agency/4. latest project.png"),
          title: "App Elements"
        },
        {
          img: require("./src/assets/designs/digital agency/5. Contact us.png"),
          title: "App Elements"
        },
      ],
      technologies: ["Figma", "Illustrator"],
      category: "Visual Design",
      github: "",
      date: "Dec, 2021",
      visit: "",
      description:
        ""
    },
    {
      name: "Credit card design",
      title: "Illustration",
      pictures: [
        {
          img: require("./src/assets/designs/credit/behance cover.png"),
          title: "MoodBoard"
        },
        {
          img: require("./src/assets/designs/credit/degisning.png"),
          title: "Degisning"
        },
        {
          img: require("./src/assets/designs/credit/Dual tune.png"),
          title: "Dual tune"
        },
        {
          img: require("./src/assets/designs/credit/Glassmorphism.png"),
          title: "Glassmorphism"
        },
        {
          img: require("./src/assets/designs/credit/Gradiant.png"),
          title: "Gradiant"
        },
        {
          img: require("./src/assets/designs/credit/Monochrome.png"),
          title: "Monochrome"
        },
        {
          img: require("./src/assets/designs/credit/Neumorphism.png"),
          title: "Neumorphism"
        },
      ],
      technologies: ["Figma", "Illustrator"],
      category: "Visual Design",
      github: "",
      date: "Dec, 2021",
      visit: "",
      description:
        ""
    },
    {
      name: "BOOKSI",
      title: "E-Book library - UI/UX Design",
      pictures: [
        {
          img: require("./src/assets/designs/booksi/behance cover.png"),
          title: "Cover"
        },
        {
          img: require("./src/assets/designs/booksi/behance board.png"),
          title: "MoodBoard"
        },
        {
          img: require("./src/assets/designs/booksi/login.png"),
          title: "login"
        },
        {
          img: require("./src/assets/designs/booksi/register.png"),
          title: "register"
        },
        {
          img: require("./src/assets/designs/booksi/home page.png"),
          title: "homepage"
        },
        {
          img: require("./src/assets/designs/booksi/For you.png"),
          title: "just for you"
        }
      ],
      technologies: ["Figma", "Photoshop"],
      category: "Visual Design",
      github: "",
      date: "Nov, 2021",
      visit: "",
      description:
        " BOOKSI is Ebook android app for easy read books."
    },
    {
      name: "Quiet Weather",
      title: "UI/UX Design",
      pictures: [
        {
          img: require("./src/assets/designs/weather/Wooden Hand iPhone 12 Pro.png"),
          title: "MoodBoard"
        },
        {
          img: require("./src/assets/designs/weather/artboard.png"),
          title: "show"
        },
        {
          img: require("./src/assets/designs/weather/weather app react native.png"),
          title: "components"
        },
      ],
      technologies: ["Figma", "Illustration"],
      category: "Visual Design",
      github: "",
      date: "Nov, 2021",
      visit: "",
      description:
        "Quiet Weather is a react native app by openweathermap api, i designed the ui/ux and coding it in react native, enjoy it!"
    },
    {
      name: "Pill Reminder",
      title: "Pill Reminder - Mockup Design",
      pictures: [
        {
          img: require("./src/assets/designs/pill reminder/Web 1.png"),
          title: "Moodboard"
        },
        {
          img: require("./src/assets/designs/pill reminder/1.png"),
          title: "Mockups 1"
        },
        {
          img: require("./src/assets/designs/pill reminder/2.png"),
          title: "Mockups 2"
        }
      ],
      technologies: ["XD", "Illustrator"],
      category: "Visual Design",
      github: "",
      date: "Apr, 2021",
      visit: "",
      description:
        "pill reminder app for nessecary drugs for the day."
    },
  ],
  portfolio: [
    {
      name: "SQUARE (웹)",
      pictures: [
        {
          img: require("./src/assets/portfolio/square_web/exam (1).png")
        },
        {
          img: require("./src/assets/portfolio/square_web/exam (2).png")
        },
        {
          img: require("./src/assets/portfolio/square_web/exam (3).png")
        },
        {
          img: require("./src/assets/portfolio/square_web/exam (4).png")
        },
        {
          img: require("./src/assets/portfolio/square_web/exam (5).png")
        }
      ],
      video: "https://drive.google.com/uc?export=download&id=1RvR0Dfvtewc3TfrRU15QzeaGQ5zsjF8B",
      technologies: ["Web", "Flutter"],
      category: "웹 앱",
      date: "",
      github: "https://github.com/jamesdev297/square_web",
      visit: "https://jamesdev297.github.io/square_build/",
      description:
        "1:1 채팅, 단체 채팅 서비스. (클라이언트)"
    },
    {
      name: "SQUARE (모바일 앱)",
      pictures: [
        {
          img: require("./src/assets/portfolio/square_mobile/exam (1).png")
        },
        {
          img: require("./src/assets/portfolio/square_mobile/exam (2).jpeg")
        },
        {
          img: require("./src/assets/portfolio/square_mobile/exam (3).jpeg")
        },
        {
          img: require("./src/assets/portfolio/square_mobile/exam (4).jpeg")
        },
        {
          img: require("./src/assets/portfolio/square_mobile/exam (5).jpeg")
        }
      ],
      video: "https://drive.google.com/uc?export=download&id=1BsiHKJxzAH1UROlqPExiSmzVBvyB-rQp",
      technologies: ["Mobile", "Flutter"],
      category: "모바일 앱",
      date: "",
      description: "1:1 채팅, 단체 채팅 서비스. (클라이언트)"
    },
  ],
  portfolio_2: [
    {
      name: "배틀 오브 레전드 (게임)",
      pictures: [
        {
          img: require("./src/assets/portfolio/loc/exam (1).png")
        },
        {
          img: require("./src/assets/portfolio/loc/exam (2).png")
        },
        {
          img: require("./src/assets/portfolio/loc/exam (3).png")
        },
        {
          img: require("./src/assets/portfolio/loc/exam (4).png")
        }
      ],
      youtube: "https://www.youtube.com/embed/WiffVlqpG2M",
      technologies: ["Game", "Unity", "C#", "실시간 PvP 멀티"],
      category: "웹 앱",
      date: "",
      github: "https://github.com/jamesdev297/project_loc_portfolio",
      visit: "https://www.pugstudio.org/bol",
      description:
          "실시간 PvP 멀티 대전 액션 게임 (클라이언트)"
    }
  ],
};

export default info;
